module.exports = __webpack_public_path__ + "img/no-data.26cafe82.svg";